import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || "";
const POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST || "https://eu.i.posthog.com";

let initialized = false;

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
  });
  initialized = true;
}

export type StoryVariant = "roma" | "universal";

export function getStoryVariant(): StoryVariant {
  if (!POSTHOG_KEY) {
    return (localStorage.getItem("vd-story-variant") as StoryVariant) || "universal";
  }
  const flag = posthog.getFeatureFlag("story-variant");
  if (flag === "roma") return "roma";
  return "universal";
}

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export { posthog };
